import { createContext, useContext } from "react";
import type { ReactNode } from "react";

/**
 * Coarse access level for the admin shell.
 * `admin` maps to the Kinde `employee` role; `uploader` maps to
 * `bruce-uploader` and may only reach the Bruce library.
 */
export type AdminAccessRole = "admin" | "uploader";

const AdminAccessContext = createContext<AdminAccessRole>("admin");

export const AdminAccessProvider = ({
  role,
  children,
}: {
  readonly role: AdminAccessRole;
  readonly children: ReactNode;
}): ReactNode => <AdminAccessContext.Provider value={role}>{children}</AdminAccessContext.Provider>;

/** Access role of the signed-in user. Defaults to `admin` (dev bypass). */
export const useAdminAccess = (): AdminAccessRole => useContext(AdminAccessContext);
